export enum UserStatus {
  ANONYMOUS = 'ANONYMOUS',
  REGISTERED = 'REGISTERED',
  TEMPORARY = 'TEMPORARY'
}
